import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { history } from "./historyService";
const reactPlugin: ReactPlugin = new ReactPlugin();
const appInsights: ApplicationInsights = new ApplicationInsights({
	config: {
		instrumentationKey: process.env.REACT_APP_APPINSIGHTS_INSTRUMENTATION_KEY,
		extensions: [reactPlugin],
		extensionConfig: {
			[reactPlugin.identifier]: { history },
		},
	},
});
appInsights.loadAppInsights();
export { reactPlugin, appInsights };
